import { createContext } from 'react';

export const defaultSettings = {
  colorPreset: 'garante',
  paletteMode: 'light',
};

export const initialState = {
  ...defaultSettings,
  isInitialized: true,
};

export const SettingsContext = createContext({
  ...initialState,
  handleToggleTheme: () => {},
});
